export default {
    unlock: 'hordeClassScholar',
    icon: 'mdi-school',
    baseStats: {
        attack: 2,
        health: 250
    },
    exp: {
        base: 18000,
        increment: 2.1
    },
    skills: {},
    skillTree: [
        {isInnate: true, level: 0, items: []},
    ],
    quests: {
        stat: [],
        zone: [],
        level: [],
        boss: []
    }
}
